import { render } from "./2Section.vue?vue&type=template&id=0ce840b3&scoped=true"
import script from "./2Section.vue?vue&type=script&lang=js"
export * from "./2Section.vue?vue&type=script&lang=js"

import "./2Section.vue?vue&type=style&index=0&id=0ce840b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce840b3"]])

export default __exports__